import angular from 'angular';
import './styles.styl';

const icons = require.context('./icons', false, /\.svg$/);

export default angular
	.module('ui.cian.icon', [])
	.directive('cianUiIcon', ['$compile', $compile => ({
		replace: true,
		scope: {
			name: '@'
		},
		link(scope, element) {
			const svgTmpl = icons(`./${scope.name}.svg`);
			const iconSvg = angular.element(svgTmpl).attr('class', 'cui-icon cui-icon_' + scope.name);
			// Создаём DOM-элемент, так как у svg нет свойств innerHTML/outerHTML
			const $htmlEl = angular.element('<div>').append(iconSvg);
			element.html($htmlEl[0].innerHTML);

			$compile(element.contents())(scope);
		}
	})])
	.name;



// WEBPACK FOOTER //
// ./~/@cian/ui/app/components/icon/index.jsm